var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.4196 100.643H13.3304C7.09866 100.643 2 95.5442 2 89.3125V21.3304C2 15.0987 7.09866 10 13.3304 10H96.4196C102.651 10 107.75 15.0987 107.75 21.3304V89.3125C107.75 95.5442 102.651 100.643 96.4196 100.643ZM13.3304 17.5536C11.2531 17.5536 9.55357 19.2531 9.55357 21.3304V89.3125C9.55357 91.3897 11.2531 93.0893 13.3304 93.0893H96.4196C98.4969 93.0893 100.196 91.3897 100.196 89.3125V21.3304C100.196 19.2531 98.4969 17.5536 96.4196 17.5536H13.3304Z",
    fill: "#636365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4369 62.8767C26.3597 62.8767 24.6602 61.1771 24.6602 59.0999V51.5463C24.6602 49.4691 26.3597 47.7695 28.4369 47.7695C30.5142 47.7695 32.2137 49.4691 32.2137 51.5463V59.0999C32.2137 61.1771 30.5142 62.8767 28.4369 62.8767ZM54.8744 62.8767C52.7972 62.8767 51.0977 61.1771 51.0977 59.0999V51.5463C51.0977 49.4691 52.7972 47.7695 54.8744 47.7695C56.9517 47.7695 58.6512 49.4691 58.6512 51.5463V59.0999C58.6512 61.1771 56.9517 62.8767 54.8744 62.8767ZM81.3119 62.8767C79.2347 62.8767 77.5352 61.1771 77.5352 59.0999V51.5463C77.5352 49.4691 79.2347 47.7695 81.3119 47.7695C83.3892 47.7695 85.0887 49.4691 85.0887 51.5463V59.0999C85.0887 61.1771 83.3892 62.8767 81.3119 62.8767Z",
    fill: "#636365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerCode);
export default __webpack_public_path__ + "static/media/ownerCode.c89ee3d1.svg";
export { ForwardRef as ReactComponent };